import CommonAPIService from 'src/servicehandlers/CommonHandler';

export class ScopesAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  createScope(scopeData, router) {
    const url = '/api/scopes';
    return this.CommonAPIService.postCall(url, scopeData, router);
  }

  deleteScope(id, router) {
    const url = `/api/scopes/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }
  updateScope(id, parms, router) {
    const url = `/api/scopes/${id}`;
    return this.CommonAPIService.putCall(url, parms, router);
  }

  getScopes(router) {
    const url = '/api/scopes';
    return this.CommonAPIService.getCall(url, null, router);
  }

  getScopeById(id, router) {
    const url = `/api/scopes/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  searchScopes(search, router) {
    const url = `/api/scopes?search=${search}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getAuthgroupScopes(authgroup_id, router) {
    const url = `/api/scopes/${authgroup_id}/authgroups`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  addScopesToAuthgroup(authgroup_id, scopes, router) {
    const url = `/api/scopes/${authgroup_id}/scopeadd`;
    return this.CommonAPIService.putCall(url, {scopes}, router);
  }

  linkScopesToAuthGroup(authgroup_id, scopes, router) {
    const url = `/api/scopes/${authgroup_id}/${scopes}/link`;
    return this.CommonAPIService.getCall(url, '' , router);
  }
}

export default ScopesAPIService;
